import createApiService from "../../http";

const ADD_DATA_CATEGORY = "dataCategory";
const UPDATE_DATA_CATEGORY = "dataCategory";
const DATASET = "dataSet";
const DATA_VALUE = "dataValue";
const DELETE_DATA_CATEGORY = "dataCategory";

const SUB_DATA_CATEGORY = 'subDataCategory';
const DATA_CATEGORY = 'dataCategory';



export const updateCategoryService = ({ token, id }) =>
  createApiService({
    method: "put",
    endpoint: `${UPDATE_DATA_CATEGORY}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });


export const addDataCategoryService = (token) =>
  createApiService({
    method: "post",
    endpoint: ADD_DATA_CATEGORY,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const deleteDataCategoryService = ({ token, id }) =>
  createApiService({
    method: "delete",
    endpoint: `${DELETE_DATA_CATEGORY}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchDataCategoriesService = () =>
  createApiService({
    method: "get",
    endpoint: ADD_DATA_CATEGORY,
    options: {
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchDataCategoryService = (id) =>
  createApiService({
    method: "get",
    endpoint: `${DATA_CATEGORY}/${id}`,
    options: {
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchSubDataCategoriesService = (categoryId) =>
  createApiService({
    method: "get",
    endpoint: SUB_DATA_CATEGORY,
    options: {
      params: { categoryId },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchDataSetsService = (params) =>
  createApiService({
    method: "get",
    endpoint: DATASET,
    options: {
      params,
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchDataValuesService = (params) =>
  createApiService({
    method: "get",
    endpoint: DATA_VALUE,
    options: {
      params,
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

// SUB CATEGORY
export const updateSubDataCategoryService = (token, id) =>
  createApiService({
    method: "put",
    endpoint: `${SUB_DATA_CATEGORY}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const addSubDataCategoryService = (token) => createApiService({
  method: "post",
  endpoint: SUB_DATA_CATEGORY,
  options: {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    baseURL: process.env.REACT_APP_BUDGIT_URL,
  },
});

export const deleteSubDataCategory = ({ token, id }) =>
  createApiService({
    method: "delete",
    endpoint: `${SUB_DATA_CATEGORY}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const addDataSet = (token) =>
  createApiService({
    method: "post",
    endpoint: DATASET,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });


export const deleteDatasetService = (token, id) =>
  createApiService({
    method: "delete",
    endpoint: DATASET,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
      data: {
        dataSetIds: id
      }
    },
  });

export const uploadDataService = (token) =>
  createApiService({
    method: "post",
    endpoint: "projects/upload-data",
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_LOCAL_BACKEND_URL,
    },
  });

export const fetchExcelCategoriesService = () =>
  createApiService({
    method: "get",
    endpoint: "data/categories",
    options: {
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchExcelIndicationsService = (category) =>
  createApiService({
    method: "get",
    endpoint: "data/indications",
    options: {
      params: { category },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchExcelChartDataService = (params) =>
  createApiService({
    method: "get",
    endpoint: "data/chart-data",
    options: {
      params,
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchExcelYearsService = (category) =>
  createApiService({
    method: "get",
    endpoint: "data/years",
    options: {
      params: category ? { category } : {},
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchTrendingCategoriesService = () =>
  createApiService({
    method: "get",
    endpoint: "data/categories",
    options: {
      params: { trending: true },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchCountriesService = () =>
  createApiService({
    method: "get",
    endpoint: "projects/countries",
    options: {
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const exportCSVService = (category) =>
  createApiService({
    method: "get",
    endpoint: "projects/export-csv",
    options: {
      params: { category },
      responseType: 'blob',
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });